<template>
    <form :action="formAction" method="POST" ref="esewaForm">
        <input :value=esewaData.data.tAmt name="tAmt" type="hidden">
        <input :value=esewaData.data.amt name="amt" type="hidden">
        <input :value=esewaData.data.txAmt name="txAmt" type="hidden">
        <input :value=esewaData.data.psc name="psc" type="hidden">
        <input :value=esewaData.data.pdc name="pdc" type="hidden">
        <input :value=esewaData.data.scd name="scd" type="hidden">
        <input :value=esewaData.data.pid name="pid" type="hidden">
        <input :value=esewaData.data.su type="hidden" name="su">
        <input :value=esewaData.data.fu type="hidden" name="fu">
    </form>
</template>
<script>
export default {
    name: 'EsewaForm',
    props: ['esewaData'],
    data: ()=>({
        formAction: 'https://uat.esewa.com.np/epay/main'
    }),
    created() {
        
        this.$bus.on('submit-esewa-form', () => {
            if(this.formAction) {
                this.$refs.esewaForm.submit();
            }
        });
    },
}
</script>
<style lang="scss" scoped>
    
</style>